import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button, Heading, Link, Text, VStack } from 'components/ui';
import HeaderNav from 'components/HeaderNav/HeaderNav';
import { StickyCtaLayout } from 'components/ui/StickyCtaLayout';
import { SUBSCRIBED_HOME_PATH } from '../../utils/subscribedHome';

type Props = {
  title: string;
  intro?: ReactNode;
  children: ReactNode;
  actionArea?: ReactNode;
  showBack?: boolean;
  testID?: string;
};

export const AccountPage = ({
  title,
  intro,
  children,
  actionArea,
  showBack = false,
  testID,
}: Props) => {
  const navigate = useNavigate();
  const goBack = () => navigate(SUBSCRIBED_HOME_PATH);

  return (
    <StickyCtaLayout
      actionArea={
        actionArea && (
          <VStack align="center" gap={4} w="100%">
            {actionArea}
            {showBack && (
              <Link
                color="secondary.500"
                fontSize="14px"
                fontWeight={600}
                href={SUBSCRIBED_HOME_PATH}
                isExternal={false}
                onClick={(event) => {
                  event.preventDefault();
                  goBack();
                }}
              >
                Cancel
              </Link>
            )}
          </VStack>
        )
      }
      header={<HeaderNav />}
      maxWidth="formWidth"
      testID={testID}
    >
      <VStack align="stretch" gap={4} w="100%">
        {showBack && (
          <Button
            alignSelf="flex-start"
            fontSize="sm"
            gap="2px"
            h="auto"
            minH="auto"
            onClick={goBack}
            px={0}
            py={0}
            variant="link"
          >
            <ChevronLeft aria-hidden size={16} />
            Back
          </Button>
        )}

        <Heading textStyle="heading.h2">{title}</Heading>

        {intro && (
          <Text
            color="blueGray.600"
            fontSize="15px"
            lineHeight="1.45"
            textAlign="center"
          >
            {intro}
          </Text>
        )}

        {children}
      </VStack>
    </StickyCtaLayout>
  );
};
